import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.scss';

const NAV_ITEMS = [
  { href: '#about', label: '서비스 소개' },
  { href: '#features', label: '주요 기능' },
  { href: '#flow', label: '주문 흐름' },
  { href: '#join', label: '입점 안내' },
  { href: '#contact', label: '문의하기' },
];

function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`Header ${scrolled ? 'is-scrolled' : ''}`}>
      <div className="Header-inner inner">
        <Link to="/" className="Header-logo" onClick={() => setOpen(false)}>
          <span className="Header-logoMark material-icons" aria-hidden>
            local_cafe
          </span>
          <span className="Header-logoText">
            <strong>카페앱모아</strong>
            <em>cafe app more</em>
          </span>
        </Link>

        <nav className={`Header-nav ${open ? 'is-open' : ''}`}>
          {NAV_ITEMS.map((item) => (
            <a key={item.href} href={item.href} onClick={() => setOpen(false)}>
              {item.label}
            </a>
          ))}
          <Link to="/appmanage/login" className="Header-cta" onClick={() => setOpen(false)}>
            점주 로그인
          </Link>
        </nav>

        <button
          type="button"
          className="Header-toggle"
          aria-label="메뉴 열기"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}>
          <span />
          <span />
          <span />
        </button>
      </div>
    </header>
  );
}

export default Header;
